/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { CreatePaymentOrderConfigurationRequest } from '../models/CreatePaymentOrderConfigurationRequest';
import type { Link } from '../models/Link';
import type { PaymentOrder } from '../models/PaymentOrder';
import type { PaymentOrderConfiguration } from '../models/PaymentOrderConfiguration';
import type { PaymentOrderConfigurationRequest } from '../models/PaymentOrderConfigurationRequest';
import type { PaymentOrderInputRequest } from '../models/PaymentOrderInputRequest';
import type { RedoReplyReturnType } from '../models/RedoReplyReturnType';
import type { SignInfo } from '../models/SignInfo';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class PaymentOrdersService {

    /**
     * Payment redo/reply/return configuration from transaction
     * Configuration resource for creating a payment order from existing transaction.
     * @returns PaymentOrderConfiguration A payment order create configuration.
     * @throws ApiError
     */
    public static getPaymentOrderConfigFromTransaction({
        externalTransactionId,
        type,
        features,
    }: {
        /**
         * External transaction identifier (as described in WebApi specification).
         */
        externalTransactionId: string,
        /**
         * Type of transaction action from which payment configuration is created
         */
        type: RedoReplyReturnType,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPaymentOrderConfigFromTransaction({
        externalTransactionId,
        type,
        features,
    }: {
        /**
         * External transaction identifier (as described in WebApi specification).
         */
        externalTransactionId: string,
        /**
         * Type of transaction action from which payment configuration is created
         */
        type: RedoReplyReturnType,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static getPaymentOrderConfigFromTransaction({
        externalTransactionId,
        type,
        features
    }: {
        /**
         * External transaction identifier (as described in WebApi specification).
         */
        externalTransactionId: string,
        /**
         * Type of transaction action from which payment configuration is created
         */
        type: RedoReplyReturnType,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/accounts/transactions/{externalTransactionId}/payment-orders/configuration',
            path: {
                'externalTransactionId': externalTransactionId,
            },
            query: {
                'type': type,
                'features': features,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Payment redo/reply/return configuration from transaction
     * Configuration resource for creating a payment order from existing transaction
     * @returns PaymentOrderConfiguration A payment order create configuration.
     * @throws ApiError
     */
    public static createPaymentOrderConfigFromTransaction({
        externalTransactionId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External transaction identifier (as described in WebApi specification).
         */
        externalTransactionId: string,
        /**
         * Type of transaction action from which payment configuration is created
         */
        type: RedoReplyReturnType,
        /**
         * Input for a payment order create configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static createPaymentOrderConfigFromTransaction({
        externalTransactionId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External transaction identifier (as described in WebApi specification).
         */
        externalTransactionId: string,
        /**
         * Type of transaction action from which payment configuration is created
         */
        type: RedoReplyReturnType,
        /**
         * Input for a payment order create configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static createPaymentOrderConfigFromTransaction({
        externalTransactionId,
        type,
        requestBody,
        features
    }: {
        /**
         * External transaction identifier (as described in WebApi specification).
         */
        externalTransactionId: string,
        /**
         * Type of transaction action from which payment configuration is created
         */
        type: RedoReplyReturnType,
        /**
         * Input for a payment order create configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/transactions/{externalTransactionId}/payment-orders/configuration',
            path: {
                'externalTransactionId': externalTransactionId,
            },
            query: {
                'type': type,
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Payment configuration from template
     * Configuration resource for creating a payment order from template
     * @returns PaymentOrderConfiguration A template payment order create configuration.
     * @throws ApiError
     */
    public static getPaymentOrderConfigFromTemplate({
        externalAccountId,
        externalTemplateId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External template identifier (as described in WebApi specification).
         */
        externalTemplateId: string,
        /**
         * Input for a template payment order create configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPaymentOrderConfigFromTemplate({
        externalAccountId,
        externalTemplateId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External template identifier (as described in WebApi specification).
         */
        externalTemplateId: string,
        /**
         * Input for a template payment order create configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static getPaymentOrderConfigFromTemplate({
        externalAccountId,
        externalTemplateId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External template identifier (as described in WebApi specification).
         */
        externalTemplateId: string,
        /**
         * Input for a template payment order create configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/templates/{externalTemplateId}/payment-orders/configuration',
            path: {
                'externalAccountId': externalAccountId,
                'externalTemplateId': externalTemplateId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Payment order configuration
     * Configuration resource for creating a new payment order.
     * @returns PaymentOrderConfiguration A payment order create configuration.
     * @throws ApiError
     */
    public static createPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static createPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static createPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/payment-orders/configuration',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Transfer payment order configuration
     * Configuration resource for creating a new transfer payment order.
     * @returns PaymentOrderConfiguration A transfer payment order create configuration.
     * @throws ApiError
     */
    public static createTransfersPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a transfer payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static createTransfersPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a transfer payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static createTransfersPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a transfer payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/payment-orders/transfers/configuration',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Direct debit payment order configuration
     * Configuration resource for creating a new direct debit payment order.
     * @returns PaymentOrderConfiguration A direct debit payment order create configuration.
     * @throws ApiError
     */
    public static createDirectDebitPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a direct debit payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static createDirectDebitPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a direct debit payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static createDirectDebitPaymentOrderConfiguration({
        externalAccountId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a direct debit payment order create configuration.
         */
        requestBody: CreatePaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/payment-orders/direct-debits/configuration',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Edit payment order configuration
     * Configuration resource for editing an existing payment order.
     * @returns PaymentOrderConfiguration A payment order edit configuration.
     * @throws ApiError
     */
    public static editPaymentOrderConfiguration({
        externalAccountId,
        externalPaymentOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
        /**
         * Input for a payment order edit configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static editPaymentOrderConfiguration({
        externalAccountId,
        externalPaymentOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
        /**
         * Input for a payment order edit configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrderConfiguration>;
    public static editPaymentOrderConfiguration({
        externalAccountId,
        externalPaymentOrderId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
        /**
         * Input for a payment order edit configuration.
         */
        requestBody: PaymentOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/payment-orders/{externalPaymentOrderId}/configuration',
            path: {
                'externalAccountId': externalAccountId,
                'externalPaymentOrderId': externalPaymentOrderId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Create a payment order
     * Create a payment order based on the payment input data.
     * @returns PaymentOrder Created payment order
     * @throws ApiError
     */
    public static createPaymentOrder({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a payment order creation.
         */
        requestBody: PaymentOrderInputRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static createPaymentOrder({
        externalAccountId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a payment order creation.
         */
        requestBody: PaymentOrderInputRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrder>;
    public static createPaymentOrder({
        externalAccountId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Input for a payment order creation.
         */
        requestBody: PaymentOrderInputRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/payment-orders',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Edit existing payment order
     * Edit existing payment order based on the payment input data.
     * @returns PaymentOrder Updated payment order
     * @throws ApiError
     */
    public static editPaymentOrder({
        externalAccountId,
        externalPaymentOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
        /**
         * Input for a payment order modification.
         */
        requestBody: PaymentOrderInputRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static editPaymentOrder({
        externalAccountId,
        externalPaymentOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
        /**
         * Input for a payment order modification.
         */
        requestBody: PaymentOrderInputRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PaymentOrder>;
    public static editPaymentOrder({
        externalAccountId,
        externalPaymentOrderId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
        /**
         * Input for a payment order modification.
         */
        requestBody: PaymentOrderInputRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/accounts/{externalAccountId}/payment-orders/{externalPaymentOrderId}',
            path: {
                'externalAccountId': externalAccountId,
                'externalPaymentOrderId': externalPaymentOrderId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete existing payment order
     * Delete a payment order identified by account id and payment order id.
     * @returns any Sign info in cases where signing is necessary in order to delete the payment order
     * @throws ApiError
     */
    public static deletePaymentOrder({
        externalAccountId,
        externalPaymentOrderId,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static deletePaymentOrder({
        externalAccountId,
        externalPaymentOrderId,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<{
        signInfo: SignInfo;
        _links?: {
            sign?: Link;
        };
    }>;
    public static deletePaymentOrder({
        externalAccountId,
        externalPaymentOrderId
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External payment order identifier (as described in WebApi specification).
         */
        externalPaymentOrderId: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'DELETE',
            url: '/public/accounts/{externalAccountId}/payment-orders/{externalPaymentOrderId}',
            path: {
                'externalAccountId': externalAccountId,
                'externalPaymentOrderId': externalPaymentOrderId,
            },
        });
    }

}
